import { render, staticRenderFns } from "./ArtifactGroups.vue?vue&type=template&id=d8bd880c&scoped=true&"
import script from "./ArtifactGroups.vue?vue&type=script&lang=js&"
export * from "./ArtifactGroups.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactGroups.vue?vue&type=style&index=0&id=d8bd880c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bd880c",
  null
  
)

export default component.exports